import { IconWrapper } from '../runtime';
export default IconWrapper('help', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "8",
      "cy": "11.9997",
      "r": "1",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.01246 9.36627V9.05212V9.05212C8.01246 8.81203 8.25229 8.58029 8.41783 8.4064C8.57031 8.24623 8.81171 7.99877 9.1939 7.61658C10.2435 6.56702 10.076 5.29303 9.1939 4.48089C8.62463 3.95675 7.66383 3.82878 7.00369 4.23253C6.22314 4.70991 5.97265 5.30471 5.97265 6.06736M15 7.99973C15 11.8657 11.866 14.9997 8 14.9997C4.13401 14.9997 1 11.8657 1 7.99973C1 4.13373 4.13401 0.999725 8 0.999725C11.866 0.999725 15 4.13373 15 7.99973Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});